// state
const state = {
  modal: {
    title: '',
    user: '',
    component: {},
    formData: {},
    pageNumber: '',
    action: '',
    show: false,
    software: '',
    width:false,
    __key: 0
  }
}

// getters
const getters = {
  structure: (state) => {
    return state.modal;
  }
}

// mutations
const mutations = {
  update(state, modal) {
    const prevKey =
      state &&
      state.modal &&
      typeof state.modal.__key === 'number'
        ? state.modal.__key
        : 0;
    // Bump a monotonically increasing key on every open/update so the dynamic
    // component re-mounts and can't show stale state (e.g., issue list caching).
    state.modal = Object.assign({}, modal, { __key: prevKey + 1 });
  }
}

// actions
const actions = {

  update({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  DemoDateUpdate({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  quickView({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  suitableDateUpdate({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  createRejectForm({commit }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },

  uploadDemoVideoLink({commit }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  uploadPlanPrice({commit }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  organizationSettingsLink({commit }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  AddOnSettingsLink({commit }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },

  uploadDocument({commit }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  orgquickView({commit }, modal) {
    modal.show = true;
    modal.width=true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  progressquickView({commit }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  updateStatus({commit }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  trialenddate({commit }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  trialDateForm({commit }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },

  completeDemoForm({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  incompleteDemoForm({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  EstimatedValue({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  deleteDemoRequest({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  deleteUser({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  leaveUser({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  passwordReset({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  editProfile({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  editLead({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  updateUser({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);  
    window.$('#modal').modal('show');
  },
  createUser({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  onBoarding({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  createOrg({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  assignLead({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  transferLead({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  transferLeadHistory({
    commit
  }, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  close({
    commit
  }, modal) {
    modal.show = false;
    window.$('#modal').modal('hide');
  },
  taskModal({commit}, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },

  quicktaskModal({commit}, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },

  ticketInDevelopment({commit}, modal) {
    modal.show = true;
    window.$('#modal').modal('show');
  },
  taskQuickView({commit}, modal) {
    modal.show = true;
    modal.width=true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
  quickTaskView({commit}, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
//support ticket message
  setStmDeliveryDate({commit}, modal) {
    modal.show = true;
    commit('update', modal);
    window.$('#modal').modal('show');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}